import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './index.css';
import './i18n';
import { initializeMonitoring, initializePerformanceMonitoring } from './utils/monitoring';

window.addEventListener('error', (event) => {
  const msg = event.message || '';
  if (
    msg.includes('is not defined') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('Importing a module script failed')
  ) {
    const root = document.getElementById('root');
    if (root && !root.dataset.recovered) {
      root.dataset.recovered = 'true';
      root.innerHTML = `
        <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:system-ui,sans-serif;background:#f9fafb;padding:1rem;">
          <div style="max-width:28rem;text-align:center;background:#fff;border-radius:0.75rem;box-shadow:0 4px 6px -1px rgba(0,0,0,.1);padding:2rem;">
            <h1 style="font-size:1.25rem;font-weight:700;color:#111;margin-bottom:0.75rem;">Application Update Available</h1>
            <p style="color:#6b7280;margin-bottom:1.5rem;">A new version has been deployed. Please reload to get the latest version.</p>
            <button onclick="window.location.reload()" style="padding:0.625rem 1.5rem;background:#2563eb;color:#fff;border:none;border-radius:0.5rem;font-weight:500;cursor:pointer;">
              Reload Page
            </button>
          </div>
        </div>
      `;
    }
  }
});

initializeMonitoring();
initializePerformanceMonitoring();

const SentryApp = Sentry.withProfiler(App);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryApp />
  </StrictMode>
);
